<template>
  <div>
    <div class="d-flex justify-content-between align-item-center mb-3">
      <div class="section-title mb-3">{{ $t("version") }}</div>
    </div>

  <div class="all-details-container">
      <div class="col-md-12">
        <div class="row" v-if="Version.length > 0">
          <div v-for="(item,index) in Version" :key="index" class="col-md-12 py-2">
            <div
              class="row border-bottom p-2"
              v-for="(objKey,index1) in Object.keys(item)" :key="index1"
            >
              <div  class="col-lg-3">{{ objKey }}</div>
              <div class="col-lg-9">{{ item[objKey] }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  data() {
    return {
      Version: [],
    };
  },
  beforeMount() {
    this.checkFileExist();
  },
  methods: {
    checkFileExist: function () {
      var url = "";
      var http = new XMLHttpRequest();

      http.open("HEAD", "/version/version.json", false);
      http.send();

      if (http.status && http.status == 200) {
        axios.get("/version/version.json").then((response) => {
          console.log("response :>> ", response);
          this.Version.push(response.data);
          console.log('this.Version :>> ', this.Version);
        });
      } else {
        this.$toasted.show(`File doesn't exists`);
      }
    },
  },
};
</script>




// WEBPACK FOOTER //
// src/components/Pages/MasterContainer/VersionComponent/version.vue